<!--  -->
<template>
  <div class="classification">
    <div class="header">
      <span class="font">{{name}}商品分类</span>
    </div>

    <div class="center"
         style="position:relative">
      <el-form :model="ruleForm"
               :rules="rules"
               ref="ruleForm"
               label-width="130px"
               class="demo-ruleForm">
        <el-form-item label="分类名称"
                      prop="name">
          <el-input v-model="ruleForm.name"
                    clear
                    size="small"
                    style="width: 400px;"></el-input>
        </el-form-item>
        <el-form-item label="上级分类"
                      prop="goodsOneClassId">
          <el-select v-model="ruleForm.goodsOneClassId"
                     @change="changeGoods"
                     :disabled="name == '编辑' && !row.goodsTwoClassId && !row.goodsThreeClassId"
                     :clearable="(name == '编辑' && !row.goodsOneClassId) || name == '新增'"
                     size="small"
                     style="width: 190px"
                     placeholder="分类">
            <el-option v-for="item in goodsclassOneList"
                       :label="item.name"
                       :value="item.id"
                       :key="item.id"></el-option>
          </el-select>
          <el-select v-model="ruleForm.goodsTwoClassId"
                     :clearable="(name == '编辑' && !row.goodsTwoClassId) || name == '新增'"
                     v-show="(name == '新增' && ruleForm.goodsOneClassId) || (name == '编辑' && row.goodsThreeClassId)"
                     size="small"
                     style="width: 190px;;margin-left:20px"
                     placeholder="分类">
            <el-option v-for="item in goodsclassTwoList"
                       :label="item.name"
                       :value="item.id"
                       :key="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="导航推荐"
                      prop="navigationRecommed">
          <el-checkbox-group v-model="ruleForm.navigationRecommed">
            <el-checkbox label="PC">PC</el-checkbox>
            <el-checkbox label="移动端">移动端</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item label="是否启用"
                      prop="enable">
          <el-checkbox-group v-model="ruleForm.enable">
            <el-checkbox label="PC">PC</el-checkbox>
            <el-checkbox label="移动端">移动端</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item label="排序"
                      prop="sort">
          <el-input v-model="ruleForm.sort"
                    type="number"
                    clear
                    size="small"
                    style="width: 190px;"></el-input>
        </el-form-item>
        <el-form-item label="PC分类图标"
                      prop="pcClassImg">
          <ImgUpload v-model="ruleForm.pcClassImg"
                     :isEdit="false"
                     :limit="1"
                     style="position:relative;top:-8px">
            <template slot="tip">
              <p class="el-upload__tip"
                 style="margin:0px">
                上传图片大小需低于2M，图片格式PNG,JPG,JPEG，页面中图片建议尺寸100*100
              </p>
            </template>
          </ImgUpload>
        </el-form-item>
        <el-form-item label="PC主题图标"
                      prop="pcThemeImg">
          <ImgUpload v-model="ruleForm.pcThemeImg"
                     :isEdit="false"
                     :limit="1"
                     style="position:relative;top:-8px">
            <template slot="tip">
              <p class="el-upload__tip"
                 style="margin:0px">
                上传图片大小需低于2M，图片格式PNG,JPG,JPEG，页面中图片建议尺寸100*100
              </p>
            </template>
          </ImgUpload>
        </el-form-item>
        <el-form-item label="移动端分类图标"
                      prop="mobileClassImg">
          <ImgUpload v-model="ruleForm.mobileClassImg"
                     :isEdit="false"
                     :limit="1"
                     style="position:relative;top:-8px">
            <template slot="tip">
              <p class="el-upload__tip"
                 style="margin:0px">
                上传图片大小需低于2M，图片格式PNG,JPG,JPEG，页面中图片建议尺寸100*100
              </p>
            </template>
          </ImgUpload>
        </el-form-item>
        <el-form-item label="移动端主题图标"
                      prop="mobileThemeImg">
          <ImgUpload v-model="ruleForm.mobileThemeImg"
                     :isEdit="false"
                     :limit="1"
                     style="position:relative;top:-8px">
            <template slot="tip">
              <p class="el-upload__tip"
                 style="margin:0px">
                上传图片大小需低于2M，图片格式PNG,JPG,JPEG，页面中图片建议尺寸100*100
              </p>
            </template>
          </ImgUpload>
        </el-form-item>
        <el-form-item>
          <el-button type="primary"
                     size="small"
                     @click="submitForm('ruleForm')">确认</el-button>
          <el-button size="small"
                     @click="resetForm('ruleForm')">取消</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import ImgUpload from '@/components/imgUpload'
import { goodsclassOne, goodsclassTwo, goodsclassSave, goodsclassSelectOne, goodsclassEdit, queryClassList } from '@/api/productManage/goodsManger'
// import avater from "/public/img/default.png"

export default {
  name: 'WareProduct',
  components: { ImgUpload },
  data () {
    return {
      row: {
        goodsOneClassId: '1232',
        goodsTwoClassId: '1',
        goodsThreeClassId: '3',
      },
      level: '',
      id: '',
      goodsclassOneList: [],
      goodsclassTwoList: [],
      name: '',
      ruleForm: {
        goodsOneClassId: '',
        goodsTwoClassId: '',
        id: '',
        level: '',
        name: '',
        parentId: '',
        sort: '',
        navigationRecommed: [],
        enable: [],
        pcClassImg: [],
        pcThemeImg: [],
        mobileClassImg: [],
        mobileThemeImg: [],
      },
      rules: {
        name: [
          { required: true, message: '请输入分类名称', trigger: 'blur' }

        ]
      }
    }
  },
  computed: {},
  watch: {},
  created () {
    this.name = this.$route.query.name || '新增'
    this.id = this.$route.query.id || ''
    this.level = this.$route.query.level || ''
    if (this.name == '编辑') {
      this.goodsclassSelectOne()
    } else {
      this.goodsclassOne()
    }
  },
  mounted () {

  },
  beforeCreate () { },
  beforeMount () { },
  beforeUpdate () { },
  updated () { },
  beforeDestroy () { },
  destroyed () { },
  activated () { },
  methods: {
    // 查询一级分类
    goodsclassOne () {
      goodsclassOne().then(res => {
        if (res.code == 0) {
          this.goodsclassOneList = res.data
          if (this.ruleForm.goodsOneClassId) {
            this.changeGoods()
          }
        }
      })
    },
    // 切换一级分类
    changeGoods () {
      if (this.ruleForm.goodsOneClassId) {
        goodsclassTwo(this.ruleForm.goodsOneClassId).then(res => {
          if (res.code == 0) {
            this.goodsclassTwoList = res.data
            this.ruleForm.goodsTwoClassId = ''
          }
        })
      }
    },
    // 提交表单
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let params = this.setParams('submit', this.ruleForm)
          if (this.name == '新增') {
            goodsclassSave(params).then(res => {
              if (res.code == 0) {
                this.$message.success('新增成功')
                this.$router.push('/productManage/goodsManage-classification-index')
              } else {
                this.$message.error('新增失败')
              }
            })
          } else {
            if (this.row.goodsThreeClassId && !params.goodsTwoClassId) {
              this.$message.warning('请选择二级分类')
              return
            }
            params.level = this.level
            goodsclassEdit(params).then(res => {
              if (res.code == 0) {
                this.$message.success('操作成功')
                this.$router.push('/productManage/goodsManage-classification-index')
              } else {
                this.$message.error('操作失败')
              }
            })
          }
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    // 取消
    resetForm (formName) {
      this.$router.push('/productManage/goodsManage-classification-index')
    },
    // 处理参数
    setParams (type, ruleForm) {
      if (type == 'submit') {
        let params = {
          ...ruleForm
        }
        params.enable = params.enable.length > 0 ? params.enable.join() : ''
        params.navigationRecommed = params.navigationRecommed.length > 0 ? params.navigationRecommed.join() : ''
        params.pcClassImg = params.pcClassImg.length > 0 ? params.pcClassImg.join() : ''
        params.pcThemeImg = params.pcThemeImg.length > 0 ? params.pcThemeImg.join() : ''
        params.mobileClassImg = params.mobileClassImg.length > 0 ? params.mobileClassImg.join() : ''
        params.mobileThemeImg = params.mobileThemeImg.length > 0 ? params.mobileThemeImg.join() : ''
        if (this.name == '新增') {
          if (params.goodsOneClassId) {
            params.level = '2'
            params.parentId = params.goodsOneClassId
            if (params.goodsTwoClassId) {
              params.level = '3'
              params.parentId = params.goodsTwoClassId
            }
          } else {
            params.level = '1'
            params.parentId = '0'
          }
        } else {
          if (params.goodsOneClassId) {
            params.level = '1'
            params.parentId = '0'
            if (params.goodsTwoClassId) {
              params.level = '2'
              params.parentId = params.goodsOneClassId
              if (params.goodsThreeClassId) {
                params.level = '3'
                params.parentId = params.goodsTwoClassId
              }
            }
          }
        }

        return params
      } else {
        let params = {
          ...ruleForm
        }
        params.enable = params.enable ? params.enable.split(',') : []
        params.navigationRecommed = params.navigationRecommed ? params.navigationRecommed.split(',') : []
        params.pcClassImg = params.pcClassImg ? params.pcClassImg.split(',') : []
        params.pcThemeImg = params.pcThemeImg ? params.pcThemeImg.split(',') : []
        params.mobileClassImg = params.mobileClassImg ? params.mobileClassImg.split(',') : []
        params.mobileThemeImg = params.mobileThemeImg ? params.mobileThemeImg.split(',') : []
        return params
      }
    },
    // 根据ID查询
    goodsclassSelectOne () {
      goodsclassSelectOne(this.id).then(res => {
        if (res.code == 0) {
          this.ruleForm = this.setParams('get', res.data)
          this.queryClassList()
          // this.goodsclassOne()
        }
      })
    },

    // 根据ID查询
    queryClassList () {
      let params = {
        id: this.id,
        level: this.level
      }
      queryClassList(params).then(res => {
        if (res.code == 0) {
          this.row = res.data
          this.$set(this.ruleForm, 'goodsOneClassId', this.row.goodsOneClassId)
          if (this.level == '2') {
            this.$set(this.ruleForm, 'goodsTwoClassId', this.row.goodsTwoClassId)
          } else if (this.level == '3') {
            this.$set(this.ruleForm, 'goodsTwoClassId', this.row.goodsTwoClassId)
            this.$set(this.ruleForm, 'goodsThreeClassId', this.row.goodsThreeClassId)
          }
          goodsclassOne().then(res => {
            if (res.code == 0) {
              this.goodsclassOneList = res.data
              if (this.ruleForm.goodsOneClassId) {
                goodsclassTwo(this.ruleForm.goodsOneClassId).then(res => {
                  if (res.code == 0) {
                    this.goodsclassTwoList = res.data
                  }
                })
              }
            }
          })
        }
      })
    },
  }
}
</script>
<style lang='scss' scoped>
.classification {
  padding: 0px;
}
.header {
  height: 56px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0px 24px 0px 24px !important;
  border-bottom: 1px solid #f5f5f5;
  .font {
    font-size: 16px;
    font-family: PingFangSC, PingFangSC-Medium;
    font-weight: 600;
    text-align: left;
    color: #262626;
  }
  .el-form-item {
    margin: 0px 0px 0px 8px !important;
  }
}
.center {
  margin-top: 16px;
  padding: 0 24px 0 24px;
  // height: calc(100% - 120px);
  ::v-deep .imageP {
    width: calc(100% - 110px);
    p {
      margin: 0 0 0 10px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
  .shangjia {
    // position: absolute;
    // z-index: 2;
    // bottom: -45px;
  }
  ::v-deep .el-dialog__body {
    padding-bottom: 0px;
  }
}
</style>
